type Sender_Widget_Prop = {
  senderQuestionContent: String;
};

const SenderWidget = ({ senderQuestionContent }: Sender_Widget_Prop) => {
  return (
    <div className="w-full bg-gray-200 dark:bg-gray-800 border-b border-gray-400">
      <div className="flex p-4 gap-4 text-base md:max-w-2xl lg:max-w-xl xl:max-w-3xl md:py-6 lg:px-0 m-auto">
        <div className="flex-shrink-0">
          <div className="w-6 h-6 relative">
            <img
              alt="User"
              src="https://cdn-icons-png.flaticon.com/512/149/149071.png"
              className="absolute inset-0 w-full h-full"
            />
          </div>
        </div>
        <div className="flex flex-col flex-grow">
          <div className="flex flex-col gap-3">
            <div className="min-h-6 flex flex-col gap-4 break-words whitespace-pre-wrap dark:text-white">
              {senderQuestionContent}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SenderWidget;
